import { api } from '../api';

export const faqService = {
  async fetchFaqs(params) {
    return api.get('faqs', { params });
  },

  async fetchFaq(id) {
    return api.get('faqs/' + id );
  },
};